import script from "./ourStorySection.vue?vue&type=script&setup=true&lang=js"
export * from "./ourStorySection.vue?vue&type=script&setup=true&lang=js"

import "./ourStorySection.vue?vue&type=style&index=0&id=c7cea3be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7cea3be"]])

export default __exports__